export const Z_INDEX = {
  MODAL: 999,
  HEADER: 888,
  CONTENT: 777,
  PETAL: 666,
};
